export const environment = {
  apiURL: 'https://fed-api-go.eraofwe.com',
  wsEndpoint: 'wss://messaging.eraofwe.com/v1',
  production: true,
  encryptionKey: 'sewen_secrete_key',
  microRoasterWeb: 'https://microroaster.eraofwe.com/',
  horecaWeb: 'https://partners.eraofwe.com',
  roasterWeb: 'https://roaster.eraofwe.com',
  estatesWeb: 'https://estates.eraofwe.com',
  facilitatorWeb: 'https://operator.eraofwe.com',
  agroUrl: 'https://api.agromonitoring.com/agro/1.0/',
  roasterBrandProfileUrl: 'https://www.eraofwe.com/roaster',
  estateBrandProfileUrl: 'https://www.eraofwe.com/estate',
  ssoWeb: 'https://sso.eraofwe.com',
  adminWeb: 'https://admin.eraofwe.com',
  coffeeLabWeb: 'https://www.eraofwe.com/coffee-lab/',
  endUserWeb: 'https://enduser.eraofwe.com',
  consumerWeb: 'https://enduser.eraofwe.com',
  chatUploadEndPoint: 'https://messaging.eraofwe.com/v1/',
  googleTranslationAPIKey: 'AIzaSyBEDVxvYT9-dlcBz83jitndZ4xODAJiqO0',
  expWeb: 'https://exp.eraofwe.com',
  supportEmailAddress: 'support@eraofwe.com',
  outletShareUrl: 'https://eraofwe.com/coffee-outlet/welcome-aboard',
  outletQrUrl: 'https://bed-api.eraofwe.com/public/op-global-qr.svg',
  outletWeb: 'https://www.eraofwe.com/op',
  outletPortalUrl:  'https://eraofwe.com/op',
  termsUserUrl: 'https://support.eraofwe.com/en/kb/articles/general-terms-conditions-user',
  termsEntityUrl: 'https://support.eraofwe.com/en/kb/articles/general-terms-conditions-legal-entity',
  privacyPolicyUrl: 'https://support.eraofwe.com/en/kb/articles/privacy-policy',
  cookiePolicyUrl: 'https://support.eraofwe.com/en/kb/articles/cookie-policy',
  shopWeb: ' https://lofbergs.se/kaffe-online',
  version: 'v1.0.3',
  facebookUrl: 'https://www.facebook.com/eraofwe',
  twitterUrl: 'https://twitter.com/eraofweofficial',
  instagramUrl: 'https://www.instagram.com/eraofwe/',
  linkedinUrl: 'https://www.linkedin.com/company/eraofwe/',
  dataProcessingUrl: 'https://support.eraofwe.com/en/kb/articles/data-processing-agreement',
  needProtect: false,
  quandlUrl: 'https://www.quandl.com/api/v3/datasets',
  publicWeb: 'https://www.eraofwe.com',
  googleMapAPIKey: 'AIzaSyBTMSQVrk0O2l5GDQGWqI5bOMBRY_RIBq0',
  support: 'https://support.eraofwe.com/',
  EMAIL_API_KEY:'ev-d04e109c77add42b91078744f992933c',
  googleTranslationDetectEndPoint: 'https://translation.googleapis.com/language/translate/v2/detect',
  googleTranslationTranslateEndPoint: 'https://translation.googleapis.com/language/translate/v2',
  needBugherd: false,
  audienceId: 'f4f7c2427a',
  siteKey: '6LcFa4gbAAAAAMxht2hgjgQmREJ-OdOxxZ-0CuP6',
  customStoryBaseUrl: 'https://www.eraofwe.com/coffee',
  cookiePolicyLofbergsUrl: 'https://www.lofbergs.se/cookie-policy/',
  lofbergsGtmUrl: 'https://www.googletagmanager.com/gtm.js?id=GTM-N6DRBL7P',
  eraofweGtmUrl: 'https://www.googletagmanager.com/gtm.js?id=GTM-KB5PD89',
  peterLarsenGtmUrl: 'https://www.googletagmanager.com/gtm.js?id=GTM-54X2ZJDS'
 };
